import { useBlockedIntervals } from "components/Dashboard/DoctorDashboard/views/one-one-sessions/contexts/BlockedIntervalsContext";
import { useMemo } from "react";
import { useSelector } from "react-redux";
import { selectEditedBlockedIntervalPreview } from "store/calendarSidebarSlice";

const useBlockedIntervalsIncludingLiveEdits = () => {
  const { blockedIntervals } = useBlockedIntervals();
  const editedBlockedIntervalPreview = useSelector(
    selectEditedBlockedIntervalPreview,
  );

  const blockedIntervalsToDisplay = useMemo(() => {
    if (!editedBlockedIntervalPreview) {
      return blockedIntervals;
    }

    return [
      editedBlockedIntervalPreview,
      ...blockedIntervals.filter(
        (interval) =>
          interval.timeslot_id !== editedBlockedIntervalPreview?.timeslot_id,
      ),
    ];
  }, [blockedIntervals, editedBlockedIntervalPreview]);
  return blockedIntervalsToDisplay;
};

export default useBlockedIntervalsIncludingLiveEdits;
